import { Box, BoxProps, useTheme } from "@mui/material";
import { assetUrl } from "../../utils";

export const KEILogo = (props: BoxProps) => {
  const theme = useTheme();
  return (
    <Box
      component="img"
      alt="kei-finance-logo"
      src={assetUrl(
        theme.palette.mode === "light"
          ? "kei-finance-light.svg"
          : "kei-finance-dark.svg",
      )}
      {...props}
    />
  );
};
